import { BentoBoxHomepage } from "../../BentoBoxHomepage/BentoBoxHomepage";
import { jsx as _jsx } from "react/jsx-runtime";
export var BentoBoxSlice = function BentoBoxSlice(_ref) {
  var headingSection = _ref.headingSection,
    footerSection = _ref.footerSection,
    bentoBoxSection = _ref.bentoBoxSection,
    _ref$css = _ref.css,
    css = _ref$css === void 0 ? '' : _ref$css,
    _ref$template = _ref.template,
    template = _ref$template === void 0 ? 'default' : _ref$template;
  // Internally use version and bentoBoxSectionV2 for 2-card layout, for now
  if (template === 'default' && bentoBoxSection !== null && bentoBoxSection !== void 0 && bentoBoxSection.primaryCardOne && bentoBoxSection !== null && bentoBoxSection !== void 0 && bentoBoxSection.primaryCardTwo && !bentoBoxSection.primaryCardThree && !bentoBoxSection.primaryCardFour) {
    return /*#__PURE__*/_jsx(BentoBoxHomepage, {
      headingSection: headingSection,
      footerSection: footerSection,
      bentoBoxSectionV2: bentoBoxSection,
      css: css
    });
  }
  return /*#__PURE__*/_jsx(BentoBoxHomepage, {
    headingSection: headingSection,
    footerSection: footerSection,
    bentoBoxSection: bentoBoxSection,
    css: css,
    template: template
  });
};